<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>客户管理</el-breadcrumb-item>
          <el-breadcrumb-item>储值规则</el-breadcrumb-item>
        </el-breadcrumb>

  <el-row style="margin-top:10px">

       <el-col :span="23" style="text-align:right">
        <el-button size="small" type="primary" @click="searchRole()">{{$t("base.search")}}</el-button>
        <el-button  :title="$t('base.new')" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="showRole()"></el-button>
      </el-col>
  </el-row>
   <el-divider></el-divider>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            width="75"
          ></el-table-column>
          <el-table-column prop="name" label="名称">
          </el-table-column>
           <el-table-column prop="price" label="价格">
           </el-table-column>
          <el-table-column prop="discount" label="折扣">
           <template slot-scope="scope">
            {{ scope.row.discount*100}}%
            </template>
            </el-table-column>
          <el-table-column :label="$t('base.opt')" column-key="opt" width="300">
            <template  slot-scope="scope"   >
              <el-button
                size="mini"
                type="text"
                @click="showRole(scope.row)"
                >{{$t("base.edit")}}</el-button
              >
               <el-divider v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"   direction="vertical"></el-divider>
              <el-button
              v-if="user.isadmin||($store.state.permission.CreateVersion&&$store.state.permission.CreateVersion.show)"
              size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >{{$t("base.del")}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="储值规则" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
  <el-form
          :model="role"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
        <el-form-item label="名称" prop="name">
            <el-input v-model="role.name" maxlength="20"></el-input>
          </el-form-item>

          <el-form-item label="价格（元）" prop="price">
              <el-input-number v-model="role.price" :min="1" :step="1" ></el-input-number>
          </el-form-item>
          <el-form-item label="折扣" prop="discount">
              <el-input-number v-model="role.discount"  :min="0.01" :max="1" :step="0.01" ></el-input-number>
              </el-form-item>
        </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveRole()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'RoleList',
  data () {
    return {
      user: {},
      role: {
      },
      tabledata: [],
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0,
      dialogFormVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入折扣', trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.user = JSON.parse(user)
      self.searchRole()
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    showRole (row) {
      if (row) {
        this.role = Object.assign({}, row)
      } else {
        this.role = {name: '', price: 1, discount: 1}
      }
      this.dialogFormVisible = true
    },

    saveRole () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let url = '/role/money/add'
          if (this.role.innerid) {
            url = '/role/money/edit'
          }
          Vue.axios
            .post(url, this.role)
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.searchRole()
                this.dialogFormVisible = false
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },

    searchRole () {
      var self = this
      Vue.axios
        .post('/role/money/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },

    handleDelete (row) {
      this.$confirm(
        '确认删除' + row.name + '？',
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/role/money/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: self.$t('base.delSuccess')
                })
                self.searchRole()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/MoneyRole.vue